import { createStore, setStateHelper } from "@neonumy/ant-design";
import { StoreApi, UseBoundStore } from "zustand";

const initialState = {
  saveLoading: false,
  handleOkSaveButton: false,
  handleSaveAndPreview: false,
  openPreviewModal: false,
};

interface FooterStore {
  resetStore: () => void;
  saveLoading: boolean;
  handleOkSaveButton: boolean;
  handleSaveAndPreview: boolean;
  openPreviewModal: boolean;
  setSaveLoading: (saveLoading: boolean) => void;
  setHandleOkSaveButton: (handleOkSaveButton: boolean) => void;
  setHandleSaveAndPreview: (handleSaveAndPreview: boolean) => void;
  setOpenPreviewModal: (openPreviewModal: boolean) => void;
}

const useFooterStore: UseBoundStore<StoreApi<FooterStore>> = createStore<FooterStore>(
  (set: (fn: (draft: Record<string, any>) => void) => void) => ({
    ...initialState,
    resetStore: () => {
      set(() => ({
        ...initialState,
      }));
    },
    setHandleOkSaveButton: (handleOkSaveButton: boolean) => {
      setStateHelper("handleOkSaveButton", handleOkSaveButton, set);
    },
    setSaveLoading: (saveLoading: boolean) => {
      setStateHelper("saveLoading", saveLoading, set);
    },
    setHandleSaveAndPreview: (handleSaveAndPreview: boolean) => {
      setStateHelper("handleSaveAndPreview", handleSaveAndPreview, set);
    },
    setOpenPreviewModal: (openPreviewModal: boolean) => {
      setStateHelper("openPreviewModal", openPreviewModal, set);
    },
  }),
);

export default useFooterStore;
